var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"camera-content",on:{"click":_vm.onVideoPlayerTap}},[(_vm.isPlaying && !_vm.showCameraDialog && _vm.url)?_c('videoPlayer',{ref:"player",attrs:{"options":_vm.videoPlayerOptions}}):_vm._e(),_c('CameraDialog',{attrs:{"show":_vm.showCameraDialog,"url":_vm.url},on:{"handleClose":_vm.updateDialogStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }